import React from 'react';
import style from './RoutineCompleteModal.module.css';
import CupIcon from '../../assets/cupIcon.svg';
import Modal from '../Modal/Modal';
import { MdShare, MdDownload, MdImage } from 'react-icons/md';
import { toast } from 'react-toastify';

const RoutineCompletedModal = ({
	onClose,
	xp,
	workoutName,
	onShare,
	shareLink,
	onFinish,
	shareImageDataUrl,
	shareMeta,
}) => {
	const resolvedShareLink = shareLink || window.location.href;
	const shareText = [
		`I just completed ${workoutName} on Calcium.`,
		`XP: ${shareMeta?.xpEarned ?? xp} | Sets: ${shareMeta?.setsCompleted ?? 0} | Reps: ${shareMeta?.repsCompleted ?? 0}`,
		`Athlete: @${shareMeta?.username || 'calcium-user'}`,
		resolvedShareLink,
	].join('\n');

	const shareOnX = () => {
		const tweetUrl = `https://x.com/intent/tweet?text=${encodeURIComponent(shareText)}`;
		window.open(tweetUrl, '_blank');
	};

	const handleShareToFeed = () => {
		if (onShare) {
			onShare({ shareText, shareLink: resolvedShareLink, xp, workoutName });
		}
	};

	const handleCopyShareText = async () => {
		try {
			await navigator.clipboard.writeText(shareText);
			toast.success('Share text copied');
		} catch {
			toast.error('Could not copy share text');
		}
	};

	const handleDownloadShareImage = () => {
		if (!shareImageDataUrl) {
			toast.error('Share image is not ready yet');
			return;
		}
		const anchor = document.createElement('a');
		anchor.href = shareImageDataUrl;
		anchor.download = `${String(workoutName || 'workout').replace(/\s+/g, '-').toLowerCase()}-share.png`;
		anchor.click();
	};

	const handleCopyShareImage = async () => {
		if (!shareImageDataUrl) {
			toast.error('Share image is not ready yet');
			return;
		}
		if (!window.ClipboardItem || !navigator.clipboard?.write) {
			toast.error('Image copy is not supported on this browser');
			return;
		}
		try {
			const blob = await (await fetch(shareImageDataUrl)).blob();
			await navigator.clipboard.write([new window.ClipboardItem({ [blob.type]: blob })]);
			toast.success('Share image copied');
		} catch {
			toast.error('Could not copy share image');
		}
	};

	return (
		<Modal
			onClose={onClose}
			title='Routine Crushed'
			subtitle='Great work. Keep your momentum by sharing this win.'
			maxWidth={560}
		>
			<div className={style.RoutineCompleteWrapper}>
				<div className={style.ConfettiTop}>
					<span>🎉</span><span>💪</span><span>⚡</span>
				</div>

				<img src={CupIcon} alt="" className={style.RoutineCupIcon} />

				<span className={style.RoutineText}>
					You completed <strong>{workoutName}</strong> and earned <strong>{xp} XP</strong>. Keep the momentum going!
				</span>

				{shareImageDataUrl && (
					<div className={style.ShareImageCard}>
						<img src={shareImageDataUrl} alt='Workout share summary' className={style.ShareImagePreview} />
						<div className={style.ShareImageActions}>
							<button className={style.ShareImageBtn} onClick={handleCopyShareImage}>
								<MdImage /> Copy Image
							</button>
							<button className={style.ShareImageBtn} onClick={handleDownloadShareImage}>
								<MdDownload /> Download
							</button>
						</div>
					</div>
				)}

				<div className={style.ModalButtons}>
					<button className={style.ShareFeedBtn} onClick={handleShareToFeed}>
						<MdShare /> Share to Feed
					</button>
					<button className={style.ShareXBtn} onClick={shareOnX}>
						Share on X
					</button>
					<button className={style.CopyShareBtn} onClick={handleCopyShareText}>
						Copy Share Text
					</button>
					{onFinish && (
						<button className={style.FinishBtn} onClick={onFinish}>
							Finish
						</button>
					)}
					<button className={style.DismissBtn} onClick={onClose}>
						Dismiss
					</button>
				</div>
			</div>
		</Modal>
	);
};

export default RoutineCompletedModal;
